import {
	type NetworkType,
	type NFTTokenOwner,
	type RecipientTypes,
	type WalletTransferOutRequestCostDTO
} from '@capsicum/common';
import { type StaticImageData } from 'next/image';

export const MIN_FAN_TOKENS_TO_WITHDRAW = 5;

export type WalletTransferOutCostItem = {
	formattedAmountToWithdraw?: string;
	formattedConvertedPrice?: string;
	formattedFeeAmount?: string;
	formattedTotalAmount?: string;
	isCHZWithdraw?: boolean;
	isLoading: boolean;
	partner?: {
		id?: string;
		logo: StaticImageData | string;
		name: string;
	};
	transferOutCostData?: WalletTransferOutRequestCostDTO;
};

export type WalletRecipientItem = {
	blockchainAddress: string;
	exchange?: string;
	id: string;
	label?: string;
	networkType: NetworkType;
	tokenOwner?: NFTTokenOwner;
	type: RecipientTypes;
};

export const enum WalletSuccessfulWithdrawStatus {
	ERROR = 'error',
	FAILED = 'failed',
	PENDING = 'processed_with_pending_locks',
	PROCESSED = 'processed',
	PROCESSING = 'processing',
	REJECTED = 'rejected'
}
export type WalletWithdrawFanTokens = {
	amount?: number;
	enabled?: boolean;
	formattedAmount?: string;
	id?: string;
	isCC2Enabled?: boolean;
	isExternalToken?: boolean;
	minAmount?: number;
	partnerName?: string;
	shortCode?: string;
	smartContractAddress?: string;
	url?: string;
};

export type WalletWithdrawDetails = {
	walletWithdrawFanTokens?: Array<WalletWithdrawFanTokens>;
};

export const enum WithdrawalEvent {
	NFTWithdrawal = 'nft_withdrawal',
	TransferOut = 'transfer_out'
}
